import React from "react";
import { 
    Row,
    Col,
    Card,
    CardHeader,
    CardTitle,
    Button,
    CardBody,
    Table,
    UncontrolledTooltip,
    Label,
    FormGroup,
    Input,
    Collapse
} from "reactstrap";
import Async from 'react-select/async';
import { isEqual } from 'lodash';
// Requests
import { 
    getUnitsRequest,
    deleteUnitRequest,
    markUnitAsReservedRequest,
    markUnitAsSoldRequest,
    cancelUnitReservationRequest,
    cancelUnitSaleRequest
} from "api/units";
import { 
    getProjectsRequest,
    getProjectRequest
} from "api/project";
import { generateUnitExportRequest } from "api/export";
import { transferUnitRequest } from "api/units";
import { getClientsRequest, getClientRequest } from "api/client";
import { signInRequest } from "api/auth";
// Helpers
import { hasPermission } from "helpers/auth";
import { calcStartEndPage } from "helpers/pagination";
import { formatUnitStatus } from "helpers/status";
import { formatPrice } from "../../helpers/pricing";
import { 
    calculateTotalPaymentAmountClient, 
    calculateTotalPaymentAmountTransfer 
} from "helpers/payment";
import { getCredentials } from "helpers/auth";
// Components
import PaginationComponent from "components/Custom/Pagination";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import MarkAsSoldModal from "components/Unit/MarkAsSoldModal";
import MarkAsReservedModal from "components/Unit/MarkAsReservedModal";
import ActionsDropdown from "components/ActionsDropdown/ActionsDropdown";
import TransferUnitModal from "components/Unit/TransferUnitModal";
import CancelReservationModal from "components/Unit/CancelReservationModal";
// Constants
import { unitStatuses } from "../../constants";
// Contexts
import ProjectContext from "contexts/ProjectContext";
// Assets
import { ReactComponent as IEye } from '../../assets/icons/eye.svg'
import { ReactComponent as ISlashedEye } from '../../assets/icons/slashedEye.svg'
import { ReactComponent as IClear } from '../../assets/icons/clear.svg'

class Units extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
          units: null,
          alert: null,
          total: 0,
          pages: 0,
          current_page: 0,
          start_page: 0,
          end_page: 9,
          first_page: 0,
          last_page: 0,
          loading: true,
          deleteUnitId: '',
          selectedProject: null,
          selectedUnit: {
            models: []
          },
          filters: {
              limit: 25,
              selectedClient: '',
              block_number: '',
              lot_number: ''
          },
          markAsSoldError: null,
          markAsSoldLoading: false,
          markAsReservedError: null,
          markAsReservedLoading: false,
          cancelReservationLoading: false,
          cancelSaleLoading: false,
          cancelReservationError: null,
          cancelSaleError: null,
          context:this.context,
          isCollapseOpen: true,
          password: null,
          passwordError: null,
          transferUnitLoading: null,
          transferUnitError: null
        }
        this.timeout = null;
    }
    static contextType = ProjectContext;
    
    async componentDidMount() {
        this.previousContext = this.context
        const { selectedProject } = this.context
        if(selectedProject) {
            this.updateFiltersAndFetchUnits();
        }
    }

    updateFiltersAndFetchUnits = async () => {
        const { selectedProject } = this.context
        const unitsFilters = JSON.parse(localStorage.getItem('unitsFilters')) || this.state.filters;

        if(unitsFilters.client) {    
			const client = await getClientRequest(unitsFilters.client.value);
            unitsFilters.client = { label: `${client.first_name} ${client.last_name}`, value: client._id, data: client };
		}

		if(unitsFilters.project) {
			getProjectRequest(unitsFilters.project).then(project => {
				this.setState({
					selectedProject: { label: project.name, value: project._id, data: project }
				});
			})
		}

        this.setState({
			filters: {...unitsFilters},
		}, () => {
            console.log(selectedProject, "entering");
            if(selectedProject) { 
                this.getUnits();
            }
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        if(this.previousContext.selectedProject !== this.context.selectedProject) {
            this.previousContext.selectedProject = this.context.selectedProject
            await this.updateFiltersAndFetchUnits();
        }

        if(!isEqual(prevState.filters, this.state.filters)) {
			localStorage.setItem('unitsFilters', JSON.stringify({...this.state.filters}));
		}
    }

    getUnits = async () => {
        const { selectedProject } = this.context
        const { filters } = this.state

        filters.project = selectedProject;
        
        this.setState({loading: true});
        const unitsObj = await getUnitsRequest({...filters, client: filters.client && filters.client.value});
        const units = unitsObj.units;
        const total = unitsObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            units,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    };

    
    deleteUnit = async () => {
        const { deleteUnitId } = this.state;
        console.log(deleteUnitId)
        await deleteUnitRequest(deleteUnitId);
        this.getUnits()
	}
    
    openConfirmation = (id) => () => {
        this.setState({
            deleteUnitId: id
		});
		this.deleteConfirmationModal.toggle();
    }
    
    goToPage = async (page) => {
        const { pages, filters } = this.state;
		const { start_page, end_page } = calcStartEndPage(page, pages);
        
		const unitsObj = await getUnitsRequest({...filters, page});
		const units = unitsObj.units;
        
		this.setState({
            units,
			start_page: start_page,
			current_page: page,
			end_page: end_page
		});
	};
    
    goTo = path => this.props.history.push(path);

    loadProjects = async (search, callback) => {
        const { filtersProjects } = this.state;

        this.setState({
            filtersProjects: {
                ...filtersProjects,
                search
            }
        })
        if(search) {
            const projectResponse = await getProjectsRequest(filtersProjects);
            const projects = projectResponse.projects.map(project => {
                return {
                    data: project,
                    label: `${project.name}`,
                    value: project._id
                }
            })
            callback(projects);
        }
    };

    onChangeField = (e) => {
        const { filters } = this.state; 
		const { name, value } = e.target;
		this.setState({
			filters: {
				...filters,
				[name]: value,
			},
		}, () => {
			this.getUnits();
		});
	}

    onSelectChange = (key) => (object) => {
		const { filters } = this.state; 


		if(!object) {
            this.setState({
                filters: {...filters, [key]: ""},
				selectedProject: null
            }, () => {
                this.getUnits();
            })
            return;
        } else if ( key === 'status') {
            this.setState({
                filters: {...filters, [key]: object.target.value},
            }, () => {
                this.getUnits();
            })
        } else if ( key === 'client') {
            this.setState({
                filters: {...filters, [key]: object},
            }, () => {
                this.getUnits();
            })
        } else {
            this.setState({
                filters: {...filters, [key]: object.value},
                selectedProject: object
            }, () => {
                this.getUnits();
            })
        }

	}

    setSelectedUnit = (unit) => {
        const { selectedUnit } = this.state;

        if(unit._id === selectedUnit._id) {
            this.setState({
                selectedUnit: {}
            });
        } else {
            this.setState({
                selectedUnit: unit
            });
        }
		
	}

    openMarkAsSoldModal = () => {
		this.markAsSoldModal.toggle();
	}

    openMarkAsReservedModal = () => {
        this.markAsReservedModal.toggle();
    }

    openCancelReservationModal = () => {
        this.cancelReservationModal.toggle();
    }

    openCancelSaleModalModal = () => {
        this.passwordConfirmationModal.toggle();
    }

    openTransferUnitModal = () => {
        this.transferUnitModal.toggle();
    }

    changeUnitToSold = async (data) => {

        this.setState({
            markAsSoldLoading: true
        })

        try {

            const totalPaymentAmount = calculateTotalPaymentAmountClient(data);
            const difference = totalPaymentAmount - data.tcp;

            if (Math.abs(difference) > 10) {
                this.setState({
                    markAsSoldLoading: false,
                    markAsSoldError: {
                        message: `The total amount of payments generated (PHP ${formatPrice(totalPaymentAmount)}) is different from the TCP provided (PHP ${formatPrice(data.tcp)}).
                        They must match for the payments to be generated.`
                    }
                })
            } else {

                await markUnitAsSoldRequest(data)
                this.setState({
                    markAsSoldLoading: false,
                    selectedUnit: {}
                })
                this.markAsReservedModal.toggle();
                this.getUnits()
            }

        } catch (err) {
                this.setState({
                    markAsSoldLoading: false,
                    markAsSoldError: err
                })
                return;
        }
    }

    changeUnitToReserved = async (data) => {

        this.setState({
            markAsReservedLoading: true
        })

        try {
            await markUnitAsReservedRequest(data)
            this.setState({
                markAsReservedLoading: false,
                selectedUnit: {}
            })
            this.markAsReservedModal.toggle();
            this.getUnits()

        } catch (err) {
                this.setState({
                    markAsReservedLoading: false,
                    markAsReservedError: err
                })
                return;
        }
    }

    handleExport = async () => {
        try {
            const localProject = JSON.parse(localStorage.getItem('selectedProject'));
            const resp = await generateUnitExportRequest(localProject.selectedProject);
            var blob = new Blob([resp], {type: 'application/vnd.ms-excel'});
            var downloadUrl = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "units.xls";
            document.body.appendChild(a);
            a.click();
        } catch(err) {
            console.log(err);
        }
    }

    collapseHandler = () => {
        this.setState(prevState => ({
            isCollapseOpen: !prevState.isCollapseOpen
        }))
    }

    cleanFilters = () => {
        this.setState({
            filters: {
                limit: 25,
                status: '',
                lot_number: '',
                block_number: ''
            },
            selectedProject: null 
        }, this.getUnits)
    }

    cancelReservation = async (data) => {
        this.setState({
            cancelReservationLoading: true
        });
        try {
            await cancelUnitReservationRequest(data)
            this.setState({
                cancelReservationLoading: false,
                selectedUnit: {}
            });
            this.cancelReservationModal.toggle();
            this.getUnits();
        } catch (err) {
            this.setState({
                cancelReservationLoading: false,
                cancelReservationError: err
            })
            return;
        }
    }

    cancelSale = async (data) => {
        this.setState({
            cancelSaleLoading: true
        });
        try {
            await cancelUnitSaleRequest(data)
            this.setState({
                cancelSaleLoading: false,
                selectedUnit: {}
            });
            this.cancelSaleModal.toggle();
            this.getUnits();
        } catch (err) {
            this.setState({
                cancelSaleLoading: false,
                cancelSaleError: err
            })
            return;
        }
    }

    transferUnit = async (data) => {
        this.setState({
            transferUnitLoading: true
        });

        const totalPaymentAmount = calculateTotalPaymentAmountTransfer(data);
        const difference = totalPaymentAmount - data.newTcp;

        if (!Number.isFinite(difference) || Math.abs(difference) > 10) {
            this.setState({
                transferUnitLoading: false,
                transferUnitError: {
                    message: `The total amount of payments generated (PHP ${formatPrice(totalPaymentAmount)}) is different from the TCP provided (PHP ${formatPrice(data.newTcp)}).
                    They must match for the payments to be generated.`
                }
            })
        } else {
            try {
                await transferUnitRequest(data)
                this.setState({
                    transferUnitLoading: false,
                    selectedUnit: {},
                    filters: {
                        ...this.state.filters,
                        selectedClient: null
                    }
                });
                this.transferUnitModal.toggle();
                this.getUnits();
            } catch (err) {
                this.setState({
                    transferUnitLoading: false,
                    transferUnitError: err
                })
                return;
            }
        }
    }

    checkPassword = async () => {
        const { password } = this.state;
        const { email } = getCredentials();
        this.passwordConfirmationModal.toggle();
        try {
            await signInRequest({ password, email });
            this.setState({ password: null, passwordError: null });
            this.passwordConfirmationModal.toggle();
            this.cancelSaleModal.toggle();
        } catch(err) {
            this.setState({ passwordError: err.message });
        } 
    }

    loadClients = async (search, callback) => {
		const { selectedProject } = this.context

		if(search) {
			const clientResponse = await getClientsRequest({ search, project: selectedProject });
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

    render() {
        const {
            units,
            loading,
            pages,
            end_page,
            current_page,
            start_page,
            selectedUnit,
            markAsSoldError,
            markAsSoldLoading,
            markAsReservedError,
            markAsReservedLoading,
            cancelReservationLoading,
            cancelSaleLoading,
            cancelReservationError,
            cancelSaleError,
            isCollapseOpen,
            filters,
            password,
            passwordError,
            transferUnitLoading,
            transferUnitError
        } = this.state

        const {
            status,
            block_number,
            lot_number,
            client
        } = filters;

        const actions = [
            {
                title: "Mark Selected as Reserved",
                onClick: this.openMarkAsReservedModal,
                disabled: (selectedUnit._id && selectedUnit.status === "available") ? false : true
            },
            {
                title: "Mark Selected as Sold",
                onClick: this.openMarkAsSoldModal,
                disabled: (selectedUnit._id && selectedUnit.status === "reserved") ? false : true
            },
            {
                title: "Cancel Reservation",
                onClick: this.openCancelReservationModal,
                disabled: (selectedUnit._id && selectedUnit.status === "reserved") ? false : true
            },
            {
                title: "Cancel Sale",
                onClick: this.openCancelSaleModalModal,
                disabled: (selectedUnit._id && selectedUnit.status === "sold") ? false : true
            },
            {
                title: "Transfer Unit",
                onClick: this.openTransferUnitModal,
                disabled: (selectedUnit._id && (selectedUnit.status === "sold" || selectedUnit.status === "reserved")) ? false : true
            }
        ];

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <Row className='mb-3'>
                                        <Col>
                                            <CardTitle className="d-inline-block" tag="h4">Units</CardTitle>
                                        </Col>
                                    </Row>
                                    <Row>
										<Col className="d-flex justify-content-end">
                                            <Button id='show-hide' className="filters-btn" onClick={this.collapseHandler}>
												{isCollapseOpen ? 
													<>
														<ISlashedEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Hide filters
														</UncontrolledTooltip>
													</>
												: 
													<>
														<IEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Show filters
														</UncontrolledTooltip>
													</>
												}
											</Button>
											<Button id="clean" className="filters-btn" onClick={this.cleanFilters}>
												<IClear/>
												<UncontrolledTooltip
													delay={0}
													target='clean'
												>
													Clean filters
												</UncontrolledTooltip>
											</Button>
										</Col>
									</Row>
                                    <Collapse isOpen={isCollapseOpen}>
                                        <Row>
											<Col>
												<FormGroup>
													<Label>Client</Label>
													<Async
														clearValue={""}
														value={client}
														name="client"
														options={[]}
														loadOptions={this.loadClients}
														className="basic-multi-select"
														classNamePrefix="select"
														onChange={this.onSelectChange('client')}
														placeholder="Client..."
														isClearable={true}
													/>
												</FormGroup>
											</Col>
										</Row>
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label>Status</Label>    
                                                    <Input
                                                        type="select"
                                                        className={status ? "mt-2" : 'mt-2 select__placeholder'}
                                                        onChange={this.onSelectChange('status')}
                                                        value={status}
                                                    >
                                                        <option value=''>Select Status...</option>
                                                        {unitStatuses.map(status => (
                                                            <option key={status} value={status}>{formatUnitStatus(status)}</option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label>Block Number</Label>
                                                    <Input 
                                                        placeholder="Search..."
                                                        value={block_number}
                                                        onChange={this.onChangeField}
                                                        name="block_number"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label>Lot Number</Label>
                                                    <Input
                                                        value={lot_number}
                                                        placeholder="Search..."
                                                        onChange={this.onChangeField}
                                                        name="lot_number"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                    <Row>
                                        <Col sm='12' className='d-flex justify-content-end mt-3'>
                                            {hasPermission('CreateUnit') ? <Button color="primary" className='add-btn' onClick={() => this.goTo('/unit/create')}><i className="tim-icons icon-simple-add" /> Unit</Button> : null}    
                                            <ActionsDropdown 
                                                actions={actions}
                                            />
                                            <Button color="primary" onClick={() => this.handleExport()}>Export</Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                        </Col>
                                    </Row>
                                    <Table responsive>
                                        <thead className="text-primary">
                                            <tr>
                                                {hasPermission('EditUnit') ? <th></th> : null}
                                                <th>Client</th>
                                                <th>Block Number</th>
                                                <th>Lot Number</th>
                                                <th>Status</th>
                                                <th>Net Price</th>
                                                <th>VAT</th>
                                                <th>TCP</th>
                                                
                                                <th className="text-right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { loading ? 
                                                <tr>
                                                    <td colSpan="12">Loading...</td>
                                                </tr>
                                            :
                                                <>
                                                    { units && units.length > 0 ?
                                                        units.map((unit) => {

                                                            let netPrice;

                                                            if (unit.selectedModel && unit.selectedModel.price && unit.selectedModel.discount) {
                                                                netPrice = unit.selectedModel.price - unit.selectedModel.discount;
                                                            } else if (unit.selectedModel && unit.selectedModel.price) {
                                                                netPrice = unit.selectedModel.price
                                                            } 
                                                            return (
                                                                <tr key={unit._id}>
                                                                    {hasPermission('EditUnit') &&
                                                                        <td>
                                                                            <input 
                                                                                type="checkbox" 
                                                                                checked={selectedUnit._id === unit._id ? true : false}
                                                                                onChange={() => this.setSelectedUnit(unit)}
                                                                            />
                                                                        </td>
                                                                    }
                                                                    
                                                                    <td>{unit.client ? `${unit.client.first_name} ${unit.client.last_name}` : 'N/A'}</td>
                                                                    <td>{unit.block_number || "N/A"}</td>
                                                                    <td>{unit.lot_number || "N/A"}</td>                                                          
                                                                    <td>
                                                                        <span className={unit.status === 'available' ? 'text-success' : 'text-danger'}>{formatUnitStatus(unit.status) || "N/A"}</span>
                                                                    </td>                                                          
                                                                    <td>{netPrice ? formatPrice(netPrice) : "N/A"}</td>
                                                                    <td>{unit.selectedModel && unit.selectedModel.vat ? formatPrice(unit.selectedModel.vat) : "N/A"}</td>
                                                                    <td>{unit.selectedModel && unit.selectedModel.tcp ? formatPrice(unit.selectedModel.tcp) : "N/A"}</td>
                                                                    <td className="text-right">
                                                                        <Button
                                                                            className="btn-link btn-icon"
                                                                            color="success"
                                                                            id={`tooltip-view-${unit._id}`}
                                                                            size="sm"
                                                                            onClick={() => this.goTo(`/unit?id=${unit._id}`)}
                                                                        >
                                                                            <i className="tim-icons icon-zoom-split" />
                                                                        </Button>
                                                                        <UncontrolledTooltip
                                                                            delay={0}
                                                                            target={`tooltip-view-${unit._id}`}
                                                                        >
                                                                            View
                                                                        </UncontrolledTooltip>
                                                                        {hasPermission('EditUser') ? <>
                                                                            <Button
                                                                                className="btn-link btn-icon"
                                                                                color="info"
                                                                                id={`tooltip-edit-${unit._id}`}
                                                                                size="sm"
                                                                                onClick={() => this.goTo(`/unit/edit?id=${unit._id}`)}
                                                                            >
                                                                                <i className="tim-icons icon-pencil" />
                                                                            </Button>
                                                                            <UncontrolledTooltip
                                                                                delay={0}
                                                                                target={`tooltip-edit-${unit._id}`}
                                                                            >
                                                                                Edit
                                                                            </UncontrolledTooltip>
                                                                            <Button
                                                                                className="btn-link btn-icon"
                                                                                color="danger"
                                                                                id={`tooltip-delete-${unit._id}`}
                                                                                size="sm"
                                                                                onClick={this.openConfirmation(unit._id)}
                                                                            >
                                                                                <i className="tim-icons icon-simple-remove" />
                                                                            </Button>
                                                                            <UncontrolledTooltip
                                                                                delay={0}
                                                                                target={`tooltip-delete-${unit._id}`}
                                                                            >
                                                                                Delete
                                                                            </UncontrolledTooltip>
                                                                        </> : null}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td colSpan="12">There's no unit to show</td>
                                                        </tr>
                                                    }
                                                </>
                                            }
                                        </tbody>
                                    </Table>
                                    {units && units.length > 0 &&
										<PaginationComponent
											pages={pages}
											current_page={current_page}
											start_page={start_page}
											end_page={end_page}
											goToPage={this.goToPage}
										/>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <ConfirmationModal
                        ref={el => this.deleteConfirmationModal = el}
                        title="Delete Unit"
                        buttons={[
                            { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                            { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteUnit }
                        ]}
                    >
                        Are you sure you want to delete this unit?
                    </ConfirmationModal>
                    <MarkAsSoldModal
                        ref={el => this.markAsSoldModal = el}
                        onSave={this.changeUnitToSold}
						loading={markAsSoldLoading}
                        selectedUnit={selectedUnit}
                        error={markAsSoldError}
                    />
                    <MarkAsReservedModal
                        ref={el => this.markAsReservedModal = el}
                        onSave={this.changeUnitToReserved}
						loading={markAsReservedLoading}
                        selectedUnit={selectedUnit}
                        error={markAsReservedError}
                    />
                    <CancelReservationModal
                        ref={el => this.cancelReservationModal = el}
                        onSave={this.cancelReservation}
						loading={cancelReservationLoading}
                        selectedUnit={selectedUnit}
                        error={cancelReservationError}
                    />
                    <CancelReservationModal
                        ref={el => this.cancelSaleModal = el}
                        onSave={this.cancelSale}
						loading={cancelSaleLoading}
                        selectedUnit={selectedUnit}
                        error={cancelSaleError}
                        cancelSale
                    />
                    <TransferUnitModal
                        ref={el => this.transferUnitModal = el}
                        onSave={this.transferUnit}
						loading={transferUnitLoading}
                        selectedUnit={selectedUnit}
                        error={transferUnitError}
                    />
                    <ConfirmationModal
                        ref={el => this.passwordConfirmationModal = el}
                        title="Confirm your password"
                        buttons={[
                            { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                            { title: 'Confirm', className: 'btn-danger-override btn btn-danger', onClick: this.checkPassword }
                        ]}
                    >
                        <FormGroup>
                            <Label>Password</Label>
                            <Input 
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => this.setState({ password: e.target.value })}
                                name="password"
                            />
                            { passwordError ? <span className="text-danger mt-2">{passwordError}</span> : null }
                        </FormGroup>
                    </ConfirmationModal>
                </div>
            </>
        )
    }
}


export default Units